/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  GetService,
  PostFormData,
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
// import { ImageURL } from "../../../../Environment/Environment";
// import defaultImg from "../../../../assets/img/thumbnail.jpg";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import Pagination from "../../../../Helper/Pagination";
import { MoonLoader } from "react-spinners";
// import { Switch } from "@mui/material";

export default function Salestax() {
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [error, setError] = useState(false);

  const [Salestaxlist, setSalestaxlist] = useState();

  const [tax, settax] = useState("");
  // const [area, setarea] = useState("");
  const [status, setstatus] = useState("");
  const [state_id, setstate_id] = useState("");
  const [state, setstate] = useState("");
  const [selectedState, setselectedState] = useState("");

  const [Countrylist, setCountrylist] = useState();
  const [Statelist, setStatelist] = useState();

  const [country, setcountry] = useState("");
  const [State, setState] = useState("");

  useEffect(() => {
    getSalestaxList();
    getCountryList();
  }, [search_key, currentPage]);

  const getSalestaxList = () => {
    setLoading(true);
    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };
    PostService(API_URL.GET_SALES_TAX, param).then(
      (res) => {
        console.log(res?.data);
        if (res.data.status === true) {
          setSalestaxlist(res?.data?.data?.rows);
          SetTotalPageCount(res.data.totalPages);
          SetTotalCount(res.data.totalItems);
          setCount(res.data.currentPage * param.limit);
          setLoading(false);
        } else {
          showErrorAlert(res.data?.message);
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  const getCountryList = () => {
    setLoading(true);
    PostService(API_URL.GET_COUNTRY_LIST).then(
      (res) => {
        if (res.data.status === true) {
          setCountrylist(res?.data?.data);
          setLoading(false);
        } else {
          showErrorAlert(res.data?.message);
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  const getStateList = (id) => {
    setLoading(true);
    PostService(API_URL.GET_STATE_LIST_BY_ID, { id: id }).then((res) => {
      if (res.data.status === true) {
        setStatelist(res?.data?.data);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    console.log(selectedState , state)
    settax(selectedState?.tax || '');
    setcountry(selectedState?.state?.country_id || '');
    setState(selectedState?.state?.state_id || "");
    // setstate_id(selectedState?.state_id);
  }, [selectedState]);

  const submit = (e) => {
    e.preventDefault();
    if (!tax) {
      setError(true);
      return;
    }

    setsubmitLoader(true);

    const data = { tax, country, State, id: selectedState?.id };
    const url =
      state === "Add" ? API_URL.ADD_SALES_TAX : API_URL.UPDATE_SALES_TAX;

    PostService(url, data).then((res) => {
      if (res.data.status === true) {
        showSuccessAlert(res?.data?.message, getSalestaxList);
        resetFunc();
        document.getElementById("closeEditModal").click();
      } else {
        showErrorAlert(res.data?.message);
        setError(false);
        setsubmitLoader(false);
      }
    });
  };

  function resetFunc() {
    setselectedState("");
    settax("");
    setstate_id("");
    setcountry("");
    setError(false);
    setsubmitLoader(false);
  }

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Sales Tax List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Sales Tax List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div className="align-items-center d-flex justify-content-between row">
                    <div className="col-md-4 p-0">
                      <div className="offset-md-1">
                        <button
                          className="btn btn-primary"
                          data-toggle="modal"
                          data-target="#EditModal"
                          onClick={() => {
                            setstate("Add");
                            resetFunc();
                          }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4 p-0">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>
                  <div class="table-responsive mt-4">
                    {!loading && (
                      <table class="table table-hover table-bordered table-striped">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Area</th>
                            <th className="text-center">State Name</th>
                            <th className="text-center">Tax</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Salestaxlist?.map((item, i) => (
                            <tr key={i}>
                              <td className="text-center">
                                {i + S_No_Count + 1}
                              </td>
                              <td className="text-center">
                                {item?.area ? item?.area : "N/A"}
                              </td>
                              <td className="text-center">
                                {item?.state_id ? item?.state_id : "N/A"}
                              </td>
                              <td className="text-center">
                                {item?.tax ? item?.tax : "N/A"}
                              </td>
                              <td className="text-center">
                                <span
                                  title="Edit"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setstate("Edit");
                                    setselectedState(item);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>

                                {/* <span
                                  title="Delete"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  onClick={() => {
                                    Delete(item?.id, "Banner");
                                  }}
                                >
                                  <i className="text-danger fas fa-trash"></i>{" "}
                                </span> */}
                              </td>
                            </tr>
                          ))}
                          {Salestaxlist && Salestaxlist.length === 0 && (
                            <tr>
                              <td colSpan="5" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------EDIT MODAL START---------- */}

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h4 className="modal-title" id="exampleModalLabel">
                {state} Sales Tax
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Sales Tax</label>
                  <select
                    className="form-control"
                    value={country}
                    disabled={state === 'Edit'}
                    onChange={(e) => {
                      setcountry(e?.target.value);
                      getStateList(e?.target.value);
                    }}
                  >
                    <option value="" >
                      Select
                    </option>
                    {Countrylist?.map((item, i) => (
                      <option value={item?.country_id} key={i}>
                        {item?.country_name}
                      </option>
                    ))}
                  </select>
                  {/* {error && !country && (
                    <div className="error mt-1">Country is required</div>
                  )}  */}
                </div>

                {country && (
                  <div className="form-group">
                    <label>Select State</label>
                    <select
                      className="form-control"
                      value={State}
                      disabled={state === 'Edit'}
                      onChange={(e) => setState(e?.target.value)}
                    >
                      <option value="" >
                        Select
                      </option>
                      {Statelist?.map((item, i) => (
                        <option value={item?.state_id} key={i}>
                          {item?.state_name}
                        </option>
                      ))}
                    </select>
                    {/* {error && !State && (
                    <div className="error mt-1">State is required</div>
                  )}  */}
                  </div>
                )}

                <div className="form-group">
                  <label>Tax</label>
                  <input
                    type="text"
                    name="tax"
                    value={tax}
                    className="form-control"
                    onChange={(e) => settax(e.target.value)}
                    placeholder="Tax"
                  />
                  {error && !tax && (
                    <div className="error mt-1">Tax is required</div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="closeEditModal"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : state === "Add" ? (
                    "Add"
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
